var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBoyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-boy"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13321",
    "data-name": "Path 13321",
    d: "M12,0H52A12,12,0,0,1,64,12V52A12,12,0,0,1,52,64H12A12,12,0,0,1,0,52V12A12,12,0,0,1,12,0Z",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BOY",
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1777",
    "data-name": "Rectangle 1777",
    fill: "none",
    stroke: "#132320",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 15,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1,
    y: -1,
    width: 66,
    height: 66,
    rx: 16,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_74",
    "data-name": "Mask Group 74",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-boy)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_042-man",
    "data-name": "042-man",
    d: "M113.264,46.229v5.143a.871.871,0,0,1-1.741,0V46.229a7.233,7.233,0,0,0-1.834-4.818.871.871,0,1,1,1.3-1.159A8.973,8.973,0,0,1,113.264,46.229Zm-20.617-1.91a.871.871,0,0,0-1.094.565,10.984,10.984,0,0,1-3.041,4.759.871.871,0,0,0,1.179,1.282,12.726,12.726,0,0,0,3.521-5.512.871.871,0,0,0-.565-1.094Zm7.064.565a.871.871,0,1,0-1.659.529,12.725,12.725,0,0,0,3.521,5.512.871.871,0,0,0,1.178-1.282,10.986,10.986,0,0,1-3.041-4.759Zm10.4-25.025V12.19A12.2,12.2,0,0,0,97.918,0H93.455a12.2,12.2,0,0,0-12.19,12.19v7.669A3.553,3.553,0,0,0,83.995,23.3a11.665,11.665,0,0,0,6.631,10.083v.229a3.586,3.586,0,0,1-1.018,2.519l-1.539-1.116A2.611,2.611,0,0,0,84.1,36.186l-.7,1.8A8.985,8.985,0,0,0,78,46.229v5.143a.871.871,0,0,0,1.741,0V46.229a7.293,7.293,0,0,1,4.423-6.675,26.544,26.544,0,0,0,3.187.784.871.871,0,0,0,.214-1.715l-2.315-.59.472-1.219a.87.87,0,0,1,1.323-.39l6.541,4.744a3.476,3.476,0,0,0,4.09,0l6.541-4.744a.87.87,0,0,1,1.323.39l.472,1.218-2.314.59a.871.871,0,1,0,.43,1.687c3.534-.9,3.371-.849,3.371-.849a.871.871,0,0,0,.5-1.126l-.832-2.149a2.611,2.611,0,0,0-3.969-1.171l-1.538,1.116a3.644,3.644,0,0,1-.412-.51.871.871,0,1,0-1.448.967,5.366,5.366,0,0,0,.44.572l-3.583,2.6a1.738,1.738,0,0,1-2.045,0l-3.586-2.6a5.394,5.394,0,0,0,1.324-3.116,11.647,11.647,0,0,0,14.931-11.107V19.618a.871.871,0,1,0-1.741,0V22.87a9.9,9.9,0,0,1-19.809,0c0-.067,0-7.034,0-7.106a1.656,1.656,0,0,1,2.75-1.214A14.14,14.14,0,0,0,97,17.958a.871.871,0,0,0,.718-1.419,3.022,3.022,0,0,1-.683-2.009,14.971,14.971,0,0,0,9.433,2.447.871.871,0,0,0-.131-1.737,13.208,13.208,0,0,1-9.3-2.859.871.871,0,0,0-1.34.327,4.711,4.711,0,0,0-.2,3.33,12.357,12.357,0,0,1-5.9-2.806,3.4,3.4,0,0,0-5.629,2.516v5.7a1.8,1.8,0,0,1-.98-1.593V12.19A10.46,10.46,0,0,1,93.455,1.741h4.462A10.46,10.46,0,0,1,108.366,12.19v7.669a.871.871,0,1,0,1.741,0Z",
    transform: "translate(-63.632 16.742)",
    fill: "#132320"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoyIcon);
export default __webpack_public_path__ + "static/media/boy-icon.543cb288.svg";
export { ForwardRef as ReactComponent };